module.exports = __webpack_public_path__ + "img/ico_landing-articles.548bb559.svg";